/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Local logic module actions
 */

import type { Address, LocationPois, Property, Scores, SelectedPoi } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import {
  LOADED_POI_FOR,
  LOADING_POI,
  RECEIVE_LOCATION_POIS,
  RECEIVE_LOCATION_SCORES,
  SET_POI_LOCATION,
} from '../constants'

export const loadedPoiFor = createAction<Address | Property | null, typeof LOADED_POI_FOR>(
  LOADED_POI_FOR
)

export const receiveLocationScores = createAction<Scores, typeof RECEIVE_LOCATION_SCORES>(
  RECEIVE_LOCATION_SCORES
)

export const receiveLocationPois = createAction<LocationPois, typeof RECEIVE_LOCATION_POIS>(
  RECEIVE_LOCATION_POIS
)

export const setPoiLocationAction = createAction<SelectedPoi, typeof SET_POI_LOCATION>(
  SET_POI_LOCATION
)

export const loadingPoi = createAction<boolean, typeof LOADING_POI>(LOADING_POI)
